import React, { Fragment } from "react";
import { Helmet } from "react-helmet";

export const MetaData = ({ children }) => {
  const isProd = process.env.REACT_APP_ENV === "PROD";

  return (
    <Fragment>
      <Helmet>
        {!isProd && (<meta name="robots" content="noindex" />)}
      </Helmet>
      {children}
    </Fragment>
  );
};
